import React from "react";
import dayjs from "dayjs";

export const MeasurementTable = ({
  measurements,
  metricType,
  onClickDelete = (id: string) => null,
  editable = false,
}) => (
  <table className="w-full border-collapse">
    <thead>
      <tr className="bg-gray-100">
        <th className="border p-1">
          時間
        </th>
        {metricType === 'bp' ? (
          <React.Fragment>
            <th className="border p-1">
              收縮壓
            </th>
            <th className="border p-1">
              舒張壓
            </th>
          </React.Fragment>
        ) : (
          <th className="border p-1">
            {metricType === 'glucose' && '血糖(mg/dl)'}
            {metricType === 'pulse' && '心跳(bpm)'}
            {metricType === 'oxygen' && '血氧(%)'}
            {metricType === 'temp' && '體溫(°C)'}
          </th>
        )}
      </tr>
    </thead>
    <tbody>
      {measurements.map((m, index) => (
        <tr
          key={index}
          className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
        >
          <td className="p-1">
            {/* date in human format */}
            {dayjs(m.dateTime).format('YYYY-MM-DD HH:mm:ss')}
          </td>
          {metricType === 'bp' ? (
            <React.Fragment>
              <td className="p-1">
                {m.raw.measurement.systolic}
              </td>
              <td className="p-1">
                {m.raw.measurement.diastolic}
              </td>
            </React.Fragment>
          ) : (
            <td className="p-1">
              {m.value}
            </td>
          )}
          {editable && (
            <td className="p-1">
              <i
                className="fa fa-trash text-red-500 active:text-red-800"
                onClick={() => onClickDelete(m.id)}
              />
            </td>
          )}
        </tr>
      ))}
    </tbody>
  </table>
)